// Čtení nativního textu dostupnosti v souvisejících košíku (cartCrossSellModel.js).
export default {
  /** bere jen jasné „Skladem …" */
  inStockRe: /^skladem/i,
};
